export default __webpack_public_path__ + "static/media/dig_bel_2+.afb2bbee.png";